'use strict';

module.exports = {
  LANDING_FRAME_NAME: 'braintreepaypallanding',
  FLOW_ENDPOINTS: {
    checkout: 'create_payment_resource',
    vault: 'setup_billing_agreement'
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/paypal/shared/constants.js
// module id = 332
// module chunks = 0